
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Box from "@material-ui/core/Box"
import { makeStyles } from "@material-ui/core/styles"
import * as TextLoader from "../StaticTexts/Index"
import { Button } from "@material-ui/core"
import PersonIcon from "@material-ui/icons/Person"
import ListAltIcon from "@material-ui/icons/ListAlt"
import AllInboxIcon from "@material-ui/icons/AllInbox"
import PeopleAltIcon from "@material-ui/icons/PeopleAlt"
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk"
import DescriptionIcon from "@material-ui/icons/Description"
import MessageIcon from "@material-ui/icons/Message"
import MenuBookIcon from "@material-ui/icons/MenuBook"
import BookmarksIcon from '@material-ui/icons/Bookmarks'
import axios from "axios"

const useStyles = makeStyles((theme) => ({
    container: {
        [theme.breakpoints.up("lg")]: {
            width: 1334,
        },
    },
    icon: {
        float: "left",
    },
    paper: {
        padding: theme.spacing(2),
        backgroundColor: "transparent !important",
        border: "none !important",
        boxShadow: "none",
        padding: "10px auto",
    },
    btn: {
        justifyContent: "left",
        marginBottom: "10px",
        padding: theme.spacing(1.2),
        backgroundColor: "#FFFFFF",
        fontWeight: "700",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#FFFFFF",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnActive: {
        justifyContent: "left",
        marginBottom: "10px",
        padding: theme.spacing(1.2),
        borderRadius: "10px",
        backgroundColor: "#950000",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
        width: "100%",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    whiteBox: {
        backgroundColor: "#ffffff",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    mr: {
        marginLeft: "5px",
    },
}));

const AdminMenu = ({ history, action, active }) => {

    const [staticText, setStaticText] = useState(0);
    const [countOfSMS, setCountOfSMS] = React.useState(0);
    const classes = useStyles();

    const getSMSCount = async () => {
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/accounts/smsAmount`,
                config
            );
            if (data.status === "ok") {
                setCountOfSMS(data.data);
            }
        } catch (e) {
            console.log(e);
        }
    };


    useEffect(() => {
        setStaticText(TextLoader.staticTextLoader("adminMenu", 'fa'));
        getSMSCount()
    }, []);

    const checkActive = (value) => {
        if (value === "isProducts-List") {
            if (active === "isProducts-Insert" || active === "isProducts-Edit")
                return true
        }
        else if (value === active)
            return true
        else
            return false
    }

    const iconFinder = (name) => {
        switch (name) {
            case "profile":
                return <PersonIcon />;
            case "factors":
                return <ListAltIcon />;
            case "products":
            case "products-list":
            case "products-insert":
            case "products-edit":
                return <AllInboxIcon />;
            case "users":
                return <PeopleAltIcon />;
            case "messages":
                return <PhoneInTalkIcon />;
            case "pageManager":
                return <DescriptionIcon />;
            case "comments":
                return <MessageIcon />;
            case "magazine":
                return <MenuBookIcon />;
            case "bookmarks":
                return <BookmarksIcon />;
        }
    };

    return (
        <div>
            <Box
                className={`${classes.grayBox}`}
                textAlign="center"
                px={1}
                py={2}
                m={1}
                borderRadius={10}>
                {staticText !== null && staticText.length > 0 && (
                    <>
                        <Box mb={1} pb={2} pt={2} borderRadius={10} style={{ backgroundColor: "#ac210a", color: "#fff" }}  >
                            <strong>پیامک باقیمانده : {countOfSMS}</strong>
                        </Box>
                        {staticText.map((item) => (
                            (item.visible) && (
                                <>
                                    <Link to={`/profile/${item.value.replace('is', '').toLowerCase()}`}>
                                        <Button
                                            className={
                                                (checkActive(item.value)) ? classes.btnActive : classes.btn
                                            }
                                            variant="contained">
                                            <span className={classes.icon}> {iconFinder(item.icon)}</span>
                                            <div className={classes.mr}>{item.label}</div>
                                        </Button>
                                    </Link>
                                    <br />
                                </>
                            )
                        ))}
                    </>
                )}
            </Box>
        </div>
    );
};

export default AdminMenu;
